/*
 * @Description:
 * @Date: 2024-11-05 09:46:10
 */
import { User } from '@cTypes/user';

type Duty = User['duty'];

export const DUTIES: {
  [key in Duty]: { label: string; value: Duty };
} = {
  2: { label: '工业', value: 2 },
  3: { label: '服务商', value: 3 },
  4: { label: '供应商', value: 4 },
  6: { label: '运营基地', value: 6 },
  10000: { label: '超级管理员', value: 10000 }
};

/** 角色类型 */
export enum RoleType {
  // 工业
  INDUSTRY = 1,
  // 服务商
  ASP = 2,
  // 供应商
  SUPPLIER = 3,
  // 基地
  BASE = 4,
  // 代办供应商
  DBGYS = 8
}

// 用户职能。DUTIES、ROLE、FUNCTION_CODE傻傻分不清
export const FUNCTION_CODE = {
  1: { label: '工业', value: 1 },
  2: { label: '服务商', value: 2 },
  3: { label: '供应商', value: 3 }
};
// 注销状态  1:已注销 0:正常
export const ACCOUNT_STATUS = {
  0: { label: '正常', value: 0 },
  1: { label: '已注销', value: 1 },
  2: { label: '已冻结', value: 2 }
};
